import React, { useState } from 'react'
import { Tooltip } from 'devextreme-react/tooltip'
import NPOpis from '../Opisi/NPOpis'
export default function TextItemHppe(data) {
  return (
    <div>
      <TextItemToolTip props={data} />
    </div>
  )
}

class TextItemToolTip extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }

    this.toggleSDefault = this.toggleSDefault.bind(this)
    this.toggleDDefault = this.toggleDDefault.bind(this)
  }

  toggleSDefault(e) {
    localStorage.setItem('hppo', this.props.props)
  }
  toggleDDefault(e) {
    if (localStorage.getItem('hppo')) localStorage.setItem('hppo', 'x')
  }

  render() {
    return (
      <div
        style={{ width: '100%' }}
        id={'product' + this.props.props}
        onMouseEnter={this.toggleSDefault}
        onMouseLeave={this.toggleDDefault}
      >
        <p>{this.props.props}</p>
      </div>
    )
  }
}
